/* eslint-disable class-methods-use-this */
/* eslint-disable import/prefer-default-export */

import { NotificationSeverity, Notification } from '../../storage/types';
import { HttpStatusCode } from '../../types';

export class DashBoardNotifications {
    static getForbiddenNotification = (): Notification => {
        const message = {
            message: 'We are unable to process your request. Your changes have not been saved. Please contact support.',
            severity: NotificationSeverity.Error,
        };
        return message;
    };

    static getConflictNotification = (): Notification => {
        const message = {
            message: 'We are unable to process your request. Your changes have not been saved. Please contact support.',
            severity: NotificationSeverity.Error,
        };
        return message;
    };

    static getNotFoundNotification = (): Notification => {
        const message = {
            message: 'We are unable to process your request. Your changes have not been saved. Please contact support.',
            severity: NotificationSeverity.Error,
        };
        return message;
    };

    static getPreconditionFailedNotification = (): Notification => {
        const message = {
            message: 'We are unable to process your request. Your changes have not been saved. Please contact support.',
            severity: NotificationSeverity.Error,
        };
        return message;
    };

    static getServiceUnavailableNotification = (): Notification => {
        const message = {
            message: 'We are unable to process your request. Your changes have not been saved. Please contact support.',
            severity: NotificationSeverity.Error,
        };
        return message;
    };

    static getUnprocessableNotification = (): Notification => {
        const message = {
            message: 'We are unable to process your request. Your changes have not been saved. Please contact support.',
            severity: NotificationSeverity.Error,
        };
        return message;
    };

    static getServerErrorNotification = (): Notification => {
        const message = {
            message: 'We are unable to process your request. Your changes have not been saved. Please contact support.',
            severity: NotificationSeverity.Error,
        };
        return message;
    };

    static getThirdPartyAccessNotification = (orgName: string): Notification => {
        const message = {
            message: `You no longer have access to the records for ${orgName}.  Your changes have not been saved.`,
            severity: NotificationSeverity.Error,
        };
        return message;
    };

    static getReportFormsGeneratedNotification = (): Notification => {
        const message = {
            message: 'New initial reporting and/or ongoing reporting forms have been generated',
            severity: NotificationSeverity.Information,
        };
        return message;
    };

    static getDashboardErrorNotification = (statusCode: HttpStatusCode, orgName?: string): Notification => {
        switch (statusCode) {
            case HttpStatusCode.Conflict:
                return this.getConflictNotification();
            case HttpStatusCode.Gone:
                return this.getNotFoundNotification();
            case HttpStatusCode.PreconditionFailed:
                return this.getPreconditionFailedNotification();
            case HttpStatusCode.ServiceUnavailable:
                return this.getServiceUnavailableNotification();
            case HttpStatusCode.UnprocessableEntity:
                return this.getUnprocessableNotification();
            case HttpStatusCode.Forbidden:
                return this.getForbiddenNotification();
            case HttpStatusCode.InternalServerError:
                return this.getServerErrorNotification();
            default:
                return this.getServerErrorNotification();
        }
    };
}
